type Lock={released:boolean;release:()=>Promise<void>;addEventListener:(name:string,fn:()=>void)=>void};
type Api={request:(kind:'screen')=>Promise<Lock>};
export class ScreenWakeKeeper {
 private generation=0;private lock:Lock|null=null;private pending=false;private enabled=false;
 constructor(private api:Api|undefined,private changed:(status:string)=>void){}
 async setEnabled(enabled:boolean){
  if(!enabled){this.enabled=false;this.generation++;const lock=this.lock;this.lock=null;if(lock)await lock.release().catch(()=>{});this.changed('off');return;}
  this.enabled=true;if(!this.api){this.changed('unsupported');return;}
  if(this.lock&&!this.lock.released||this.pending)return;
  const generation=this.generation;this.pending=true;
  try{const lock=await this.api.request('screen');if(!this.enabled||generation!==this.generation){await lock.release();return;}this.lock=lock;this.changed('active');lock.addEventListener('release',()=>{if(this.lock===lock){this.lock=null;this.changed(this.enabled?'released':'off');}});}
  catch{if(this.enabled&&generation===this.generation)this.changed('unavailable');}finally{this.pending=false;if(this.enabled&&generation!==this.generation)void this.setEnabled(true);}
 }
}
